export default "__VITE_ASSET__DEuoCitP__"